import {
  faArrowUpRightFromSquare,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components';

import routesConstants from '@/routes/routes.constants';

import { VoiceNotesSource } from '../types';

interface NotesPageNavigationBlurbProps {
  voiceNotesSource: VoiceNotesSource;
  onCloseSheet: () => void;
}

export const NotesPageNavigationBlurb = ({
  voiceNotesSource,
  onCloseSheet,
}: NotesPageNavigationBlurbProps) => {
  return (
    <>
      {voiceNotesSource === VoiceNotesSource.VOICE_NOTES_BUTTON && (
        <div className="vai-flex vai-items-center vai-gap-2 vai-px-2">
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="vai-text-blue-700 vai-h-4 vai-w-4 vai-flex-shrink-0"
          />
          <div className="vai-min-w-0 vai-flex-1 vai-text-sm vai-text-gray-800">
            <Trans>Your note is also available on the </Trans>
            <Button
              variant="link"
              size="sm"
              className="!vai-p-0 !vai-h-4"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // Close the sheet first, then navigate
                onCloseSheet();
                // Use requestAnimationFrame for better timing
                requestAnimationFrame(() => {
                  // Use window.location.hash for hash routing
                  window.location.hash = routesConstants.AMBIENT;
                });
              }}
            >
              <Trans>Voice Notes page</Trans>
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className="vai-text-blue-700 vai-h-4 vai-w-4 vai-flex-shrink-0 vai-inline"
              />
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
